<ng-container *ngFor="let link of links">
    <a mat-list-item
        [routerLink]="selLanguage + '/' + link.route"
        [attr.disabled]="link.isDisabled || isRouteLoading"
        [ngClass]="{disabled: link.isDisabled || isRouteLoading, little: isLittleMode, 'mobile-hidden': link.isMobileHidden}" routerLinkActive="active">
        <mat-icon>{{link.icon}}</mat-icon>
        <span class="link-label">{{link.title | translate}}</span>
    </a>
    <mat-divider></mat-divider>
</ng-container>
